import { useDispatch, useSelector } from "react-redux"
import BannerHeader from "../../../Components/BannerHeader/BannerHeader"
import CustomerReview from "../../Body/CustomerReview/CutomerReview"
import Gallery from "../../Body/Gallery/Gallery"
import Footer from "../../Footer/Footer"
import PrimaryNav from "../../Header/PrimaryNav/PrimaryNav"
import { ContactUs } from "../Components/ContactUs/ContactUs"
import ServiceVideo from "../Components/ServiceVideo/ServiceVideo"
import FAQ from "../FAQ/FAQ"
import classes from "./CorporateGifts.module.css"
import { useEffect } from "react"
import { getAllFaq } from "../../../Store/actions/FaqAction"

import AboutCorporateGifts from "./AboutCorporateGifts/AboutCorporateGifts"
import { urls } from "../../../Routes/Urls"
import useScrollToTop from "../../../Hooks/useScrollToTop";
import SEO from "../../../Components/SEO"
const bgImage = "Assets/Images/ServicePages/ForCorporateGifts.png"

const CorporateGifts = () => {
  const dispatch = useDispatch()
  const crumbs = [
    { title: "Home", path: ("/") },
    { title: "Corporate Gifts", path: urls.CORPORATEGIFTS },
  ]

  const video = useSelector((state) => state.serviceVideo?.videos?.forCorporateGiftsVideo)
  const allFaq = useSelector(state => state.Faq.questions);

  useEffect(() => {
    getAllFaq("category", "Corporate Gifting", "", dispatch)
  }, [])
  const scrollRef = useScrollToTop();

  return (
    <div ref={scrollRef}>
      <SEO
        canonicalUrl="https://www.rarebiblio.com/luxury-corporate-gifts-for-employees"
        keywords={"Luxury Corporate Gifts for Employees"}
        title={"Luxury Corporate Gifts for Employees | Custom Leather Books"}
        description={"Rare Biblio brings you high-end leather books for employee gifting. Impress your team with personalized, luxury corporate gifts. Shop now for bulk orders!"}
        structuredData={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Organization",
              "name": "Rare Biblio",
              "alternateName": "Luxury Corporate Gifts for Employees",
              "url": "https://www.rarebiblio.com/luxury-corporate-gifts-for-employees",
              "logo": "https://www.rarebiblio.com/Assets/Icons/logo.jpg",
              "sameAs": [
                "https://rarebiblio.com/",
                "https://www.linkedin.com/company/Rarebiblio",
                "https://www.pinterest.com/rare_biblio",
                "https://www.instagram.com/Rarebiblio",
                "https://www.twitter.com/Rarebiblio",
                "https://www.facebook.com/rarebiblio/"
              ]
            },
            {
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "What makes leather-bound books a high-value gift?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Leather-bound books are timeless, elegant, and sophisticated. They represent luxury and knowledge, making them the perfect gift to recognize achievements, celebrate milestones, or enhance professional relationships."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How can leather-bound books be used for employee recognition?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Leather-bound books can be personalized with the recipient’s name, accomplishments, or a special message. These make exceptional awards or tokens of appreciation, offering a lasting and meaningful way to recognize employees' hard work."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I add my company logo to the books?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! We offer full customization options, including the ability to add your company’s logo, a personalized message, or even the recipient’s name, making each gift unique and tailored to your needs."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Are there options for bulk corporate gifting?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we offer bulk ordering options for businesses of all sizes. Whether you’re looking to gift a small team or a large group of clients and employees, we can accommodate your order and deliver exceptional quality at scale."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I add personal notes inside the books for recipients?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely! You can include a personal message or dedication inside each book, making the gift even more meaningful. This customization option allows you to connect with your employees or clients on a deeper level."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I customize the books for corporate gifts?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! We offer full customization options for corporate gifts. You can personalize the leather-bound books with your company’s logo, brand colors, and custom messages. Whether you’re looking for premium gifts for clients, employees, or special events, these bespoke editions make for unique, high-end presents that leave a lasting impression."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How do I place a corporate gifting order?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "To place a corporate gifting order, simply reach out to us through our contact form or email us at info@rarebiblio.com. Our expert team will guide you through the process and help you create the perfect custom leather-bound books for your corporate needs."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I include my company’s logo or a personalized message in the books?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, you can include your company’s logo or a personalized message in the books. Your logo can be embossed on the front cover, inside, or on the back cover. Additionally, you can add a personalized message, such as a foreword or thank-you note, inside the book. These customizations enhance your brand’s presence and add a professional touch."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you offer packaging options for corporate gifts?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we offer custom packaging options for corporate gifts, including special holiday packaging tailored to your specific requirements. Whether you need festive designs, branded packaging, or unique gift wrapping, we can create a package that aligns with your brand and the occasion."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I order books in bulk for a corporate event or conference?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, you can definitely order books in bulk for a corporate event or conference. We offer a variety of options, including beautiful journals and other types of books that can be customized to suit your needs. Whether you want them branded with your logo or personalized with a special message, we can accommodate your order for large quantities."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How long does it take to receive a corporate gifting order?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The time it takes to receive a corporate gifting order depends on the number of books you're ordering. Typically, it takes about 2 to 4 weeks for delivery. However, the timeline can vary based on customization requirements and order size, so it's always a good idea to place your order in advance to ensure timely delivery."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I order a sample book before placing a large corporate order?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, you can order a sample book before placing a large corporate order. We can provide sample options tailored to your specific requirements, allowing you to review the quality and customization before committing to the full order."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Are there discounts for bulk corporate orders?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we offer discounts for bulk corporate orders. Please reach out to us directly via info@rarebiblio.com for more details, and we’ll provide you with pricing and discount options based on your order size and requirements."
                  }
                }
              ]
            }
          ]
        }}
      />
      <PrimaryNav />
      <BannerHeader 
      bgImage={bgImage} 
      crumbs={crumbs} title={"Luxury Corporate Gifts for Employees"} desc={"Unique, High-Quality Gifts that Leave a Lasting Impression"} />

    <ServiceVideo
      videoSrc={video}
      title={``}
      desc={`Our finely leather-bound books combine sophistication and intellectual stimulation, making them the ideal business gifts.We understand that your goal as a business owner is to increase your staff's knowledge, morale, and happiness.\n\n Whether for the holidays, business achievements, or special recognitions, picking the appropriate present may improve relationships and express your gratitude.\n\nAt Rare Biblio, we're experts in producing high-end, leather-bound books that are ideal for corporate gifts because they combine style, substance, and personalization in a way that will appeal to your receivers.`}
    />


      <AboutCorporateGifts />
      <div className={classes.join}>
        <h2>
          For Your Corporate Gifting Requirements, Collaborate with Rare Biblio
        </h2>
        <div className={classes.joinDesc}>
          <p>
          Leather-bound books from Rare Biblio are more than just presents; they're a tribute to your company's values and a token of gratitude to all who have helped it succeed.
          <br/> <br/>

          Get in touch with us right now at <a href="mailto:info@rarebiblio.com">info@rarebiblio.com</a> to learn more about our selection of leather-bound books and how we can assist you in crafting the ideal business present. <br/> <br/>
          Together, we can make your gift-giving experience remarkable and remarkable.

          </p>

        </div>
      </div>

      <div className={classes.contactUs}>
        <ContactUs category={"corporateGifts"} title={"Let’s Get Started"}
        />
      </div>
      <Gallery />

      <CustomerReview />

      <FAQ data={allFaq} />
     

      <Footer />
    </div>
  )
}

export default CorporateGifts